import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export default function PageHero({
  eyebrow,
  title,
  description,
  stats = [],
  action = null,
  logoSrc = null,
  logoAlt = 'Logo',
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        {logoSrc ? (
          <Box
            component="img"
            src={logoSrc}
            alt={logoAlt}
            sx={{
              height: { xs: 54, md: 62 },
              mt: 0.15,
              objectFit: 'contain',
            }}
          />
        ) : null}
        <Box>
          {eyebrow ? (
            <Typography variant="overline" sx={{ letterSpacing: '0.18em', color: '#7a859d', display: 'block', mb: 0.25 }}>
              {eyebrow}
            </Typography>
          ) : null}
          <Typography variant="h4" sx={{ mb: 0.5, color: '#25324b' }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" sx={{ color: '#7a859d', maxWidth: 680 }}>
              {description}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {(action || stats.length) ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'stretch', md: 'flex-end' },
            gap: 1.25,
            minWidth: { xs: '100%', md: 'auto' },
            pt: 0.25,
          }}
        >
          {action ? <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-end' } }}>{action}</Box> : null}
          {stats.length ? (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                gap: 1,
              }}
            >
              {stats.map((stat) => (
                <Chip
                  key={stat.label}
                  label={`${stat.label}: ${stat.value}`}
                  sx={{
                    color: '#5f6fff',
                    border: '1px solid rgba(95,111,255,0.16)',
                    background: 'rgba(255,255,255,0.92)',
                  }}
                />
              ))}
            </Box>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
}
